import store from "./redux";
// import ReactGA from "react-ga";
import { setToken, setSandboxToken, exitSandbox } from "./redux/reducers/Auth";
import { loadViewPreference } from "./redux/reducers/View";
import jwtDecode from "jwt-decode";

const safeJwtDecode = (token: string): any | null => {
  if (!token || typeof token !== "string") {
    return null;
  }
  try {
    return jwtDecode(token);
  } catch (_err) {
    return null;
  }
};

export const logUserIn = (token: string) => {
  store.dispatch(setToken(token));
  // Refresh per-contract UI preferences (e.g. tree vs. grid view) whenever
  // the active session changes.
  store.dispatch<any>(loadViewPreference());

  // ReactGA.set(getFields());
};

export const logSandboxIn = (token: string) => {
  store.dispatch(setSandboxToken(token));
  store.dispatch<any>(loadViewPreference());
};

export const leaveSandbox = () => {
  store.dispatch(exitSandbox());
  store.dispatch<any>(loadViewPreference());
};

export const getFields = () => {
  const jwt = getJwt();
  if (jwt === null) {
    return {};
  }
  const data: any = safeJwtDecode(jwt);
  if (!data) {
    return {};
  }
  // planName and billingcycle is pretty useless until we refresh
  // the JWT when the subscription status changes
  const fields: any = {
    dimension1: data.user || "-1",
    dimension3: data.planName || "",
    dimension4: data.billingCycle || "",
  };
  if (data.seat && data.seat.contractId) {
    fields.dimension2 = data.seat.contractId;
  }
  return fields;
};

export const getJwt = () => {
  let jwt = null;
  const state = store.getState();
  if (state && state.Auth && state.Auth.tokenStr) {
    jwt = state.Auth.tokenStr;
  }
  return jwt;
};

export default {
  getJwt,
  getFields,
  logUserIn,
};
